export default __webpack_public_path__ + "assets/images/37ed7b292a039ce360c398b3b90027f6.png";